import React, {useContext} from 'react';
import '../assets/styles/user_profile.css';
import {MyContext} from "../context/my_context";

export interface Profile {
    id: number,
    group: number,
    firstName: string,
    lastName: string,
    email: string,
    token: string,
    isActive: boolean
}

const UserProfile: React.FC = () => {
    const context = useContext(MyContext);

    if (!context) {
        throw new Error("UserProfile must be used within a MyProvider");
    }

    const { userData } = context;

    // Map userData properties to Profile
    const userProfile: Profile = {
        id: userData?.id || 0,
        group: userData?.grupo || 0,
        firstName: userData?.nombre ? userData.nombre.charAt(0).toUpperCase() + userData.nombre.slice(1).toLowerCase() : '',
        lastName: userData?.apellido ? userData.apellido.charAt(0).toUpperCase() + userData.apellido.slice(1).toLowerCase() : '',
        email: userData?.email || '',
        token: userData?.token || '',
        isActive: userData?.activo || false
    };

    return (
        <div className="user-profile">
            <h2>Perfil de Usuario</h2>
            {userProfile ? (
                <table className="profile-table">
                    <tbody>
                    <tr>
                        <td><strong>Nombre:</strong></td>
                        <td>{userProfile.firstName}</td>
                    </tr>
                    <tr>
                        <td><strong>Apellido:</strong></td>
                        <td>{userProfile.lastName}</td>
                    </tr>
                    <tr>
                        <td><strong>Es Activo:</strong></td>
                        <td>{userProfile.isActive ? "Si" : "No" }</td>
                    </tr>
                    <tr>
                        <td><strong>Correo Electronico:</strong></td>
                        <td>{userProfile.email}</td>
                    </tr>
                    </tbody>
                </table>
            ) : (
                <p>Cargando perfil de Usuario...</p>
            )}
        </div>
    );
};

export default UserProfile;
